/**
 * State used in rendering OptionGroup
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
